<template>
    <v-card :color="highlight ? 'grey darken-2' : 'grey darken-3'"
            @mouseover="mouseOver(true)"
            @mouseleave="mouseOver(false)"
            :class="classes"
            @click="clicked"
    >
        <v-card-text>
            <v-row>
                <v-col cols="4">
                    <v-icon medium>{{icon}}</v-icon>
                </v-col>
                <v-col cols="8">
                    <span class="subtitle-1">{{ucFirst(text)}}</span>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
    import {stringMixin} from '../mixins/stringMixin.js'

    export default {

        mixins: [stringMixin],

        components: {},

        props: {
            id: {
                type: String,
                required: false,
            },
            icon: {
                type: String,
                required: false,
            },
            text: {
                type: String,
                required: false,
            },
            clickable: {
                type: Boolean,
                required: false,
                default: false,
            }
        },

        data() {
            return {
                highlight: false,
            }
        },

        computed: {
            classes() {
                if (this.clickable) {
                    return 'pointer-active';
                }
            }
        },

        methods: {
            clicked() {
                this.$emit('click', this.id);
            },
            mouseOver(bool) {
                if (this.clickable) {
                    this.highlight = bool;
                }
            }
        }
    }
</script>

<style scoped>
    .pointer-active {
        cursor: pointer;
    }
</style>
